import { useEffect, useState } from 'react';
import { inventarioService } from '../../services/api';
import { btnSecundario, chip, pesos } from '../../components/ui/estilos';
import { entrada } from '../agenda/campos';
import { TipoMov } from './DialogosInsumo';
import { TIPO_MOV, cant, estadoInsumo, fechaCorta, num } from './insumos';

const caja: React.CSSProperties = { flex: 1, padding: '12px 14px', borderRadius: 12, background: 'var(--well)', display: 'flex', flexDirection: 'column', gap: 2 };
const etiqueta: React.CSSProperties = { fontSize: 12, fontWeight: 700, color: 'var(--muted)' };

export default function DetalleInsumo({ insumo, version, puedeBorrar, say, onMovimiento, onEditar, onCambio, onEliminado }: {
  insumo: any; version: number; puedeBorrar: boolean; say: (m: string) => void;
  onMovimiento: (t: TipoMov) => void; onEditar: () => void; onCambio: () => void; onEliminado: () => void;
}) {
  const [kardex, setKardex] = useState<any[]>([]);
  const [minimo, setMinimo] = useState(String(num(insumo.stock_minimo)));
  const e = estadoInsumo(insumo);
  const inventariado = insumo.controla_stock !== false;
  const apartado = num(insumo.stock_reservado);

  useEffect(() => { inventarioService.getMovimientos(insumo.id).then(r => setKardex(r.data)).catch(() => setKardex([])); }, [insumo.id, version]);
  useEffect(() => { setMinimo(String(num(insumo.stock_minimo))); }, [insumo.stock_minimo]);

  const guardarMinimo = async (v: number) => {
    const nuevo = Math.max(0, v);
    setMinimo(String(nuevo));
    if (nuevo === num(insumo.stock_minimo)) return;
    try { await inventarioService.actualizarInsumo(insumo.id, { stock_minimo: nuevo }); onCambio(); }
    catch { say('No se pudo guardar el mínimo.'); setMinimo(String(num(insumo.stock_minimo))); }
  };

  const eliminar = async () => {
    if (!window.confirm(`¿Eliminar el insumo "${insumo.nombre}"? Esta acción no se puede deshacer.`)) return;
    try { await inventarioService.eliminarInsumo(insumo.id); say(`${insumo.nombre} eliminado.`); onEliminado(); }
    catch (err: any) { say(err.response?.data?.error || 'No se pudo eliminar.'); }
  };

  const paso = (b: string, onClick: () => void, label: string) =>
    <button onClick={onClick} aria-label={label} style={{ ...btnSecundario, width: 44, height: 44, padding: 0, fontSize: 20 }}>{b}</button>;

  return (
    <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 18 }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'flex-start' }}>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>{insumo.nombre}</h2>
          <span style={chip(e.bg, e.fg)}>{e.label}</span>
        </div>
        <div style={{ fontSize: 15, color: 'var(--muted)' }}>{insumo.unidad} · {pesos(num(insumo.costo_unitario))} por {insumo.unidad}</div>
      </div>

      {inventariado ? <>
        <div style={{ display: 'flex', gap: 10 }}>
          <div style={caja}><span style={etiqueta}>STOCK ACTUAL</span><span style={{ fontSize: 22, fontWeight: 700 }}>{cant(insumo.stock_actual)} {insumo.unidad}</span></div>
          <div style={caja}><span style={etiqueta}>MÍNIMO</span><span style={{ fontSize: 22, fontWeight: 700 }}>{cant(insumo.stock_minimo)}</span></div>
        </div>
        {apartado > 0 && (
          <div style={{ fontSize: 14, color: 'var(--warn)', fontWeight: 700 }}>
            {cant(apartado)} {insumo.unidad} apartados por comandas abiertas · quedan {cant(insumo.stock_disponible)} para vender
          </div>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--muted)' }}>Ajustar stock mínimo</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {paso('−', () => guardarMinimo(num(minimo) - 1), 'Menos')}
            <input type="number" min="0" step="any" value={minimo} onChange={ev => setMinimo(ev.target.value)} onBlur={() => guardarMinimo(num(minimo))}
              onKeyDown={ev => ev.key === 'Enter' && (ev.target as HTMLInputElement).blur()} aria-label="Stock mínimo"
              style={{ ...entrada, flex: 1, textAlign: 'center', fontSize: 18, fontWeight: 700 }} />
            {paso('+', () => guardarMinimo(num(minimo) + 1), 'Más')}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {(['entrada', 'salida', 'merma'] as TipoMov[]).map(t => (
            <button key={t} onClick={() => onMovimiento(t)} style={{ ...btnSecundario, flex: 1, fontSize: 15 }}>+ {t[0].toUpperCase() + t.slice(1)}</button>
          ))}
        </div>
      </> : (
        <div style={{ padding: '12px 14px', borderRadius: 12, background: 'var(--well)', fontSize: 15, color: 'var(--muted)' }}>
          No se inventaría: solo cuenta para el costo de las recetas.
        </div>
      )}

      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={onEditar} style={{ ...btnSecundario, flex: 1, height: 44, fontSize: 14 }}>Editar datos</button>
        {puedeBorrar && <button onClick={eliminar} style={{ ...btnSecundario, height: 44, fontSize: 14, color: 'var(--danger)' }}>Eliminar</button>}
      </div>

      {inventariado && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--muted)', marginBottom: 4 }}>Kardex reciente</div>
          {!kardex.length && <div style={{ color: 'var(--muted)', padding: '8px 0' }}>Sin movimientos.</div>}
          {kardex.map(k => {
            const c = num(k.cantidad);
            return (
              <div key={k.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, padding: '9px 0', borderBottom: '1px solid var(--line)' }}>
                <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                  <span style={{ fontSize: 14, fontWeight: 700 }}>{k.motivo || TIPO_MOV[k.tipo] || k.tipo}</span>
                  <span style={{ fontSize: 12, color: 'var(--muted)' }}>{TIPO_MOV[k.tipo] || k.tipo} · {fechaCorta(k.created_at)} · {k.usuario}</span>
                </div>
                <span style={{ fontSize: 15, fontWeight: 700, color: c >= 0 ? 'var(--ok)' : 'var(--danger)', whiteSpace: 'nowrap' }}>{c >= 0 ? '+' : '−'}{cant(Math.abs(c))}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
